class CounterBar extends HTMLElement {

  constructor() {
    super();
    this.counterInterval = null;
  }

  elements = {
    counter: this.querySelector('#counter'),
    days: this.querySelector('[data-time=days]'),
    hours: this.querySelector('[data-time=hours]'),
    minutes: this.querySelector('[data-time=minutes]'),
    seconds: this.querySelector('[data-time=seconds]'),
  }

  connectedCallback() {
    this.init();
    this.render();
  }

  disconnectedCallback() {
    clearInterval(this.counterInterval);
  }

  init() {
    console.log("counter: init")

    // check if date has been provided
    if (this.dataset.countToDate.length < 1) {
      console.error('counter: no date set');
      this.elements.counter.classList.add('expired');
      return;
    }

    this.elements.counter.classList.add('initialized');
    
    // Set the date we're counting down to
    const countDownDate = new Date(this.dataset.countToDate).getTime();

    console.log({ d: this.dataset.countToDate, countDownDate})

    // Update the count down every 1 second
    this.counterInterval = setInterval( () => {

      // Get today's date and time
      const now = new Date().getTime();

      // Find the distance between now and the count down date
      const distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Output the result in an element with id="demo"
      if (distance > 0) {
        this.elements.days.innerHTML = days;
        this.elements.hours.innerHTML = hours;
        this.elements.minutes.innerHTML = minutes;
        this.elements.seconds.innerHTML = seconds;
      }
      else {
        // count down is over
        clearInterval(this.counterInterval);
        this.elements.counter.classList.add('expired');
      }

    }, 1000);
  }

  render() {
    console.log('todo: render')
  }

}

customElements.define('counter-bar', CounterBar);
